import { concentrationPresentation } from '../../lib/concentrationResolver'

export function needsConcentration(row = {}) {
  const value = String(row.concentration || '').trim().toLowerCase()
  if (row.catalog_id) {
    const resolved = concentrationPresentation(row)
    if (['resolved', 'resolved with conflict'].includes(resolved.status)
      && !['', 'unknown', 'ambiguous'].includes(resolved.display.toLowerCase())) return false
  }
  return ['', 'unknown', 'ambiguous'].includes(value)
}

export default function ConcentrationNeeded({ row, onClick }) {
  if (!needsConcentration(row)) return null
  const props = { title: 'Concentration still needed', 'aria-label': 'Concentration still needed' }
  return onClick
    ? <button type="button" {...props} onClick={onClick} className="shrink-0 p-2">⚠️</button>
    : <span role="img" {...props}>⚠️</span>
}
